import { useNavigate, useLocation } from 'react-router-dom'
import * as MuiIcons from '@mui/icons-material'
import { Box, Container, Tab, Tabs } from '@mui/material'

import { useMenu } from '../../hooks/useMenu'
import { useBranding } from '../../hooks/useBranding'

export function AdvisorNavbar() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { menuItems, loading, error } = useMenu('ADVISOR')
  const { getDebugBorder } = useBranding()

  // Find active tab based on current path
  const activeTab = menuItems.find((item) => pathname.startsWith(item.route))?.route || pathname

  const handleTabChange = (event, newValue) => {
    navigate(newValue)
  }

  // Get icon component from name
  const getIcon = (iconName) => {
    if (!iconName) return null
    const IconComponent = MuiIcons[iconName]
    return IconComponent ? <IconComponent /> : null
  }

  // Don't render navbar if loading or no menu items
  if (loading || menuItems.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        backgroundColor: 'info.light',
        borderBottom: 1,
        borderColor: 'divider',
        ...getDebugBorder('Advisor Navbar', '#0000FF'),
      }}
    >
      <Container maxWidth="lg">
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="advisor navigation"
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.9375rem',
              minHeight: 48,
            },
            '& .Mui-selected': {
              color: 'primary.main',
            },
          }}
        >
          {menuItems.map((item) => (
            <Tab
              key={item.key}
              label={item.label}
              value={item.route}
              icon={getIcon(item.icon)}
              iconPosition="start"
              sx={{ gap: 1 }}
            />
          ))}
        </Tabs>
      </Container>
    </Box>
  )
}
